import QuestionsService from './services';
import QuestionTypes from './types';

export const listQuestions = (pagination: any, filters?: any) =>
  QuestionTypes.list.createAction(() => QuestionsService.listQuestions(pagination, filters));
export const listChatQuestions = (chat_id: number) => QuestionTypes.listChatQuestions.createAction(() => QuestionsService.listChatQuestions(chat_id));
export const answerQuestion = (chat_id: number, content: string) =>
  QuestionTypes.answerQuestion.createAction(() => QuestionsService.answerQuestion(chat_id, content));
export const updateQuestion = (chat_id: number, id: number, questionUpdate: any) =>
  QuestionTypes.updateQuestion.createAction(() => QuestionsService.updateQuestion(chat_id, id, questionUpdate));
